/* Silver&Co. — lógica de registro e inicio de sesión.
   La tienda usa cuentas nuevas de Shopify (login por código al correo, sin contraseña):
   1) Registro: guarda el registro en el ERP (registro-web) y luego manda a Shopify a verificar el correo
      (si la clienta no existía, Shopify la crea al entrar con el código).
      El formulario es el de cliente de Shopify, que siempre suscribe a marketing y solo se acepta con el
      captcha de Shopify (que se engancha al enfocarlo y lo envía por su cuenta aunque se cancele el submit).
      Por eso: con "novedades" sigue el envío normal de Shopify, que vuelve a esta página con
      ?customer_posted=true y ahí se guarda en el ERP; sin la casilla se corta el envío antes que el captcha
      (listeners en captura sobre window) y a Shopify no llega nada.
   2) Login: manda a Shopify con el correo ya relleno (login_hint). */
(function () {
  'use strict';
  var SUPABASE_FN = 'https://nituzlaboqqetopejklk.supabase.co/functions/v1/registro-web';
  // Llave pública (rol anon): solo sirve para llamar a la función; la base está protegida por RLS.
  var SUPABASE_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5pdHV6bGFib3FxZXRvcGVqa2xrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3OTEzMzQzODksImV4cCI6MjEwNjkxMDM4OX0.-y45ABrnsskSDGUEPjnVldVRSAwrlfCueUDNX7MQg7g';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var PENDIENTE = 'sc_registro_pendiente'; // registro que espera la vuelta del envío a Shopify

  function loginUrl(root, email) {
    var base = root.getAttribute('data-login-url') || '/customer_authentication/login';
    var q = 'return_to=' + encodeURIComponent('/account');
    if (email) q = 'login_hint=' + encodeURIComponent(email) + '&' + q;
    return base + (base.indexOf('?') > -1 ? '&' : '?') + q;
  }
  function setError(input, msg) {
    var out = document.getElementById(input.getAttribute('aria-describedby'));
    input.setAttribute('aria-invalid', msg ? 'true' : 'false');
    if (out) out.textContent = msg || '';
    return !msg;
  }
  function validate(input) {
    var v = input.value.trim();
    if (input.type === 'email') return setError(input, !v ? 'Escribe tu correo.' : !EMAIL_RE.test(v) ? 'Revisa el formato del correo.' : '');
    if (input.required) return setError(input, v ? '' : 'Este campo es obligatorio.');
    return true;
  }
  function wireInputs(inputs) {
    inputs.forEach(function (i) {
      i.addEventListener('blur', function () { validate(i); });
      i.addEventListener('input', function () { if (i.getAttribute('aria-invalid') === 'true') validate(i); });
    });
  }
  // Valida todo, muestra los errores y enfoca el primero.
  function validarTodo(form, inputs) {
    var ok = true, first = null;
    inputs.forEach(function (i) { if (!validate(i)) { ok = false; first = first || i; } });
    var terms = form.querySelector('input[name=terms]');
    if (terms && !terms.checked) {
      ok = false;
      setError(terms, 'Debes aceptar los términos para continuar.');
      first = first || terms;
    }
    if (!ok) first.focus();
    return ok;
  }
  // Lo mismo sin tocar la pantalla (para decidir en el clic si el envío puede llegar a Shopify).
  function completo(form, inputs) {
    var terms = form.querySelector('input[name=terms]');
    return (!terms || terms.checked) && Array.prototype.every.call(inputs, function (i) {
      var v = i.value.trim();
      return i.type === 'email' ? EMAIL_RE.test(v) : (!i.required || !!v);
    });
  }
  // Guarda el registro en Supabase (ERP) mediante la Edge Function registro-web.
  function guardarErp(datos) {
    return fetch(SUPABASE_FN, {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'apikey': SUPABASE_ANON, 'authorization': 'Bearer ' + SUPABASE_ANON },
      body: JSON.stringify(datos)
    }).catch(function () {});
  }
  function guardarYEntrar(root, datos) {
    var go = function () { window.location.href = loginUrl(root, datos.email); };
    var t = setTimeout(go, 4000);
    guardarErp(datos).then(function () { clearTimeout(t); go(); });
  }

  var reg = document.getElementById('sc-register-form');
  if (reg) {
    var root = reg.closest('.sc-account');
    var rinputs = reg.querySelectorAll('input[type=text],input[type=email]');
    var novedades = function () { return reg.querySelector('input[name=marketing]').checked; };
    // Vuelta del envío a Shopify (solo con novedades): ?customer_posted=true, o con error de Shopify
    // (por ejemplo, correo ya registrado). En ambos casos se guarda en el ERP y se entra.
    var pendiente = null;
    try { pendiente = JSON.parse(sessionStorage.getItem(PENDIENTE) || 'null'); } catch (e) {}
    if (pendiente && (/[?&]customer_posted=true/.test(window.location.search) || reg.querySelector('[data-sc-shopify-error]'))) {
      try { sessionStorage.removeItem(PENDIENTE); } catch (e) {}
      var entrando = reg.querySelector('button[type=submit]');
      entrando.disabled = true;
      entrando.textContent = 'Entrando…';
      guardarYEntrar(root, pendiente);
    }
    wireInputs(rinputs);
    // Sin novedades (o con datos incompletos) nadie más ve el clic del botón: el captcha de Shopify no corre.
    window.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('button[type=submit]');
      if (b && b.form === reg && (!novedades() || !completo(reg, rinputs))) e.stopImmediatePropagation();
    }, true);
    window.addEventListener('submit', function (e) {
      if (e.target !== reg) return;
      var valido = validarTodo(reg, rinputs);
      var datos = {
        first_name: reg.querySelector('[name="contact[first_name]"]').value,
        last_name: reg.querySelector('[name="contact[last_name]"]').value,
        email: reg.querySelector('[name="contact[email]"]').value.trim(),
        marketing: novedades(),
        website: reg.querySelector('[name=website]').value
      };
      if (valido && datos.marketing) {
        // Con consentimiento: sigue el envío normal de Shopify (con su captcha), que suscribe y guarda
        // nombre/apellido. El ERP se guarda a la vuelta; si no hay sessionStorage, ahora.
        reg.querySelector('[name="contact[tags]"]').value = 'newsletter,registro-web';
        try { sessionStorage.setItem(PENDIENTE, JSON.stringify(datos)); } catch (err) { guardarErp(datos); }
        return;
      }
      // Sin consentimiento (o inválido): se corta aquí; a Shopify no llega nada y no se suscribe.
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!valido) return;
      reg.querySelector('button[type=submit]').disabled = true;
      guardarYEntrar(root, datos);
    }, true);
  }

  var login = document.getElementById('sc-login-form');
  if (login) {
    var lroot = login.closest('.sc-account');
    var linputs = login.querySelectorAll('input[type=text],input[type=email]');
    wireInputs(linputs);
    login.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validarTodo(login, linputs)) return;
      login.querySelector('button[type=submit]').disabled = true;
      window.location.href = loginUrl(lroot, login.querySelector('input[type=email]').value.trim());
    });
  }
})();
